import { Behavior } from "./Behavior";
import { MainPageAccessor } from "./MainPageAccessor";
import { Component } from "./Component";

export class ComponentBehavior extends Behavior {
    protected constructor() {
        super();
    }

    public fillWindowHeight(topAdjust: number = 0): string {
        return "calc(100% - " + (MainPageAccessor.pageHeaderHeight - topAdjust) + "px)";
    }

    get type(): string {
        return Component.name;
    }
}

ComponentBehavior.register();
